<template>
    <div class="hot-label-container">
        <div class="line"></div>
        <div class="title-box">
            <span class="title">热门标签</span>
        </div>
        <div class="list-box">
            <ul>
                <li v-for="(item, i) in hotLabelList" :key="i">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'HotLabel',
    data() {
        return {
            hotLabelList: []
        }
    },
    created() {
        this.getHotLabelList();
    },
    methods: {
        getHotLabelList() {
            this.hotLabelList = [
                { name: 'ChinaJoy2019' },
                { name: '斗鱼嘉年华DONEWS视觉' },
                { name: '暴雪嘉年华热点新闻' },
                { name: '暴雪嘉年华' },
                { name: '电竞' },
                { name: '动漫' },
                { name: '网易' },
                { name: '腾讯' },
                { name: 'ChinaJoy' },
                { name: 'VR' },
                { name: 'AR' },
                { name: 'APPSTORE' },
                { name: '泛二次元' },
                { name: '泛娱乐' },
                { name: '动漫' },
                { name: '资本' },
                { name: 'H5游戏' },
                { name: '独立游戏' },
                { name: '主机游戏' },
                { name: '网页游戏' }
            ]
        },
    }
}
</script>
<style lang="scss" scoped>
@import './HotLabel.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/hot-label/HotLabel.vue